/*
 * @Descripttion: 
 * @version: 
 * @Author: zhangxiaofeng
 * @Date: 2020-07-02 17:03:58
 * @LastEditors: zhangxiaofeng
 * @LastEditTime: 2020-11-04 17:25:22
 */
import SnapActor from './SnapActor';
import FeatureSnapActor from './FeatureSnapActor';
import FeatureVertexSnapActor from './FeatureVertexSnapActor';
import NearestVertexSnapActor from './NearestVertexSnapActor';
import FeatureOutLineSnapActor from './FeatureOutLineSnapActor'

export default {
    SnapActor,
    FeatureSnapActor,
    FeatureVertexSnapActor,
    NearestVertexSnapActor,
    FeatureOutLineSnapActor
};
